const DEFAULT_API_URL = "https://localhost:3000";
const DEFAULT_WS_URL = "wss://localhost:3000";
const API_PREFIX = "/api";

function ensureApiPrefix(url: string): string {
  const trimmed = url.replace(/\/+$/, "");
  if (trimmed.endsWith(API_PREFIX)) {
    return trimmed;
  }
  return `${trimmed}${API_PREFIX}`;
}

export function resolveApiUrl(): string {
  const envUrl = import.meta.env.VITE_API_URL;
  if (!import.meta.env.DEV && envUrl && envUrl.length > 0) {
    return ensureApiPrefix(envUrl);
  }

  if (typeof window !== "undefined") {
    return ensureApiPrefix(window.location.origin);
  }

  return ensureApiPrefix(DEFAULT_API_URL);
}

export function resolveWsUrl(): string {
  // Сначала пробуем явный VITE_WS_URL
  const wsEnvUrl = import.meta.env.VITE_WS_URL;
  if (!import.meta.env.DEV && wsEnvUrl && wsEnvUrl.length > 0) {
    return wsEnvUrl.replace(/\/+$/, "");
  }

  // Вычисляем из VITE_API_URL (https -> wss, http -> ws)
  const apiEnvUrl = import.meta.env.VITE_API_URL;
  if (!import.meta.env.DEV && apiEnvUrl && apiEnvUrl.length > 0) {
    const wsUrl = apiEnvUrl
      .replace(/^https:/, "wss:")
      .replace(/^http:/, "ws:")
      .replace(/\/api\/?$/, "")
      .replace(/\/+$/, "");
    return wsUrl;
  }

  // Fallback на текущий хост
  if (typeof window !== "undefined") {
    const protocol = window.location.protocol === "https:" ? "wss" : "ws";
    return `${protocol}://${window.location.host}`;
  }

  return DEFAULT_WS_URL;
}
